<template>
  <v-app>
    <v-content>
      <v-container grid-list-md>
        <front-header />
        <v-layout row
                  wrap
                  style="padding: 26px 0px;margin: 0px">
          <v-card tile
                  width="100%"
                  class="mx-auto">
            <v-tabs v-model="tab"
                    background-color="white"
                    color="#666699"
                    show-arrows>
              <v-tab v-for="(i,index) in userdata"
                     :key="index">{{ i.school }}</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item v-for="(i,index) in userdata"
                          :key="index">
                <v-layout row
                          wrap
                          style="padding: 26px5 0px;margin: 0px">
                  <v-card tile
                          width="100%"
                          class="mx-auto">
                    <v-layout justify-center
                              class="ctbanner">
                      <v-avatar :size="164"
                                tile>
                        <img :src="i.picurl ? i.picurl : i.sex === '男' ? '/uploads/usericons/txm.png' : '/uploads/usericons/txf.png'"
                             class="ava-img" />
                      </v-avatar>
                    </v-layout>

                    <v-layout class="backbj">
                      <v-layout align-end
                                fill-height>
                        <v-list-item dark
                                     color="rgba(0, 0, 0, .4)">
                          <v-list-item-content>
                            <v-list-item-title class="title">{{ i.name }}-共{{userdata.length}}份证书</v-list-item-title>
                            <v-list-item-subtitle>{{ i.fathername }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-layout>
                    </v-layout>

                    <v-layout>
                      <v-flex class="detail">
                        <v-list line>
                          <v-list-item @click>
                            <v-list-item-icon>
                              <v-icon large
                                      dark
                                      color="grey lighten-1">account_box</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title v-text="i.name"></v-list-item-title>
                              <v-list-item-subtitle>姓名</v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider inset></v-divider>
                          <v-list-item @click>
                            <v-list-item-icon>
                              <v-icon large
                                      dark
                                      color="grey lighten-1">credit_card</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title v-text="i.age"></v-list-item-title>
                              <v-list-item-subtitle>身份证号</v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider inset></v-divider>
                          <v-list-item @click>
                            <v-list-item-icon>
                              <v-icon large
                                      dark
                                      color="grey lighten-1">how_to_reg</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title v-text="i.sex"></v-list-item-title>
                              <v-list-item-subtitle>性别</v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider inset></v-divider>
                          <v-list-item @click>
                            <v-list-item-icon>
                              <v-icon large
                                      dark
                                      color="grey lighten-1">folder_open</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title v-text="i.school"></v-list-item-title>
                              <v-list-item-subtitle>证书编号</v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider inset></v-divider>
                          <v-list-item @click>
                            <v-list-item-icon>
                              <v-icon large
                                      dark
                                      color="grey lighten-1">school</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title v-text="i.fathername"></v-list-item-title>
                              <v-list-item-subtitle>职业技能名称</v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider inset></v-divider>
                          <v-list-item @click>
                            <v-list-item-icon>
                              <v-icon large
                                      dark
                                      color="grey lighten-1">format_line_spacing</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title v-text="i.fathermobile ? i.fathermobile : '暂无'"></v-list-item-title>
                              <v-list-item-subtitle>级别</v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider inset></v-divider>
                          <v-list-item @click>
                            <v-list-item-icon>
                              <v-icon large
                                      dark
                                      color="grey lighten-1">move_to_inbox</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title v-text="i.fz_date"></v-list-item-title>
                              <v-list-item-subtitle>发证日期</v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-layout>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-layout>
      </v-container>
    </v-content>
    <front-footer />
  </v-app>
</template>

<script>
import frontheader from './core/Header';
import frontfooter from './core/Footer';

export default {
  components: {
    'front-header': frontheader,
    'front-footer': frontfooter
  },
  data () {
    return {
      userdata: [],
      tab: null
    };
  },
  mounted () {
    // 发送查询请求
    this.$http
      // dev
      // .get('/api/certificates', {
      //   params: {
      //     firstname: this.$route.query.firstname,
      //     zjnum: this.$route.query.zjnum,
      //     zsbh: this.$route.query.zsbh
      //   }
      // })
      // product
      .get('/api/queryfr/certificates_query', {
        params: {
          firstname: this.$route.query.firstname,
          zjnum: this.$route.query.zjnum,
          zsbh: this.$route.query.zsbh
        }
      })
      .then(res => {
        var rcode = res.data.code;
        if (rcode !== 200) {
          this.$message({ type: 'error', message: res.data.msg, offset: 436 });
        } else {
          this.$message({ type: 'success', message: res.data.msg, offset: 436 });
          if (res.data.data.length === undefined) {
            this.userdata.push(res.data.data)
          } else {
            this.userdata = res.data.data;
          }
        }
      })
      .catch(err => {
        this.$message({ type: 'error', message: err.msg, offset: 260 });
      });
  },
  methods: {}
};
</script>

<style scoped>
.mx-auto {
  overflow: hidden;
  background-color: #3ac47d;
}
.ava-img {
  display: block;
  height: auto;
  max-width: 100%;
  padding: 26px;
}
.ctbanner {
  overflow: hidden;
  padding-top: 2%;
}
.backbj {
  text-align: center;
}

.v-list-item .v-list-item__subtitle,
.v-list-item .v-list-item__title {
  line-height: 1.3;
}

.v-list-item__subtitle {
  font-size: 1.1rem;
}
</style>
